import { AfterContentInit, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { SessionItemRow } from '../../providers/sessionItems-provider';
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { HasPendingChangesGuard } from '../../../common/guards/has-pending-changes';
import { EditableBlockInterface } from '../../editable-block-interface';
import { SessionRestEditComponent } from './session-rest-edit';
import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";
import { DurationVerbosePipe } from "../../../common/pipes/duration-verbose";
import { NgIf } from "@angular/common";
import { MatIconButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'session-rest',
  providers: [],
  standalone: true,
  styleUrls: ['./session-rest.scss'],
  imports: [
    FlexLayoutModule,
    DurationVerbosePipe,
    TranslateModule,
    NgIf,
    MatIconButton,
    MatMenuTrigger,
    MatMenuItem,
    MatTooltip,
    MatMenu,
    MatIcon,
  ],
  templateUrl: './session-rest.html'
})
export class SessionRestComponent implements EditableBlockInterface, AfterContentInit {
    @Input() public data: SessionItemRow = {} as SessionItemRow;
    @Input() public isEditable = true;
    @Input() public itsTheFirst = false;
    @Input() public itsTheLast = false;
    @Input() public parentIndex: number | undefined;
    @Output('onTimeBasedInfoUpdated') public onTimeBasedInfoUpdated: EventEmitter<any[]> = new EventEmitter<any[]>();
    @Output('onDelete') public onDelete: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output('onDuplicate') public onDuplicate: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output('onMoveUp') public onMoveUp: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output('onMoveDown') public onMoveDown: EventEmitter<SessionItemRow> = new EventEmitter<SessionItemRow>();
    @Output() public onChanged: EventEmitter<any> = new EventEmitter<any>();

    public _restTime = 0;

    public isSelected = false;

    constructor(
        private _utils: UtilsProvider,
        private _changesGuard: HasPendingChangesGuard,
    ) {
    }

    @HostListener('window:beforeunload')
    public doSomething() {
        return !this._changesGuard.hasChanges();
    }

    public editComponent(): any {
        return SessionRestEditComponent;
    }

    public toggleSelected(bool: boolean): void {
        this.isSelected = bool;
    }

    public ngAfterContentInit() {
        this._restTime = this.data.data.restTime;
    }

    public duplicate(toDuplicate: SessionItemRow): void {
        this.onDuplicate.emit(toDuplicate);
        this.onChanged.emit();
    }

    public delete(toDelete: SessionItemRow): void {
        this.onDelete.emit(toDelete);
        this.onChanged.emit();
    }

    /*
    public onRestTimeChange(event: EventEmitter<any>): void {
        this.onTimeBasedInfoUpdated.emit();
        this.onChanged.emit();
    }
    */

    public moveup(toMove: SessionItemRow): void {
        toMove.parentIndex = this.parentIndex;
        this.onMoveUp.emit(toMove);
    }

    public movedown(toMove: SessionItemRow): void {
        toMove.parentIndex = this.parentIndex;
        this.onMoveDown.emit(toMove);
    }
}
